import Dexie from 'dexie';

export const DB_NAME = 'recall';

export function createDB(name = DB_NAME) {
  const db = new Dexie(name);
  db.version(1).stores({
    decks: 'id, parentId',
    notes: 'id, deckId, type, *tags, createdAt',
    cards: 'id, noteId, deckId, due',
    reviewLogs: 'id, cardId, reviewedAt',
    outbox: '++seq, [kind+id]',
    meta: 'key',
  });
  db.version(2).stores({
    decks: 'id, parentId',
    notes: 'id, deckId, type, *tags, createdAt',
    cards: 'id, noteId, deckId, due',
    reviewLogs: 'id, cardId, reviewedAt',
    outbox: '++seq, [kind+id]',
    meta: 'key',
    settings: 'id',
  });
  return db;
}
